/* Component-specific styles only */
:host {
  display: block;
}
.message {
  padding: var(--padding-l);
  border-radius: var(--border-radius);
  margin-bottom: var(--margin-xxl);
  font-size: var(--font-size-s);
}
.message.success {
  background: var(--color-bg-secondary);
  color: var(--color-success);
  border: var(--border);
}
.slug-display {
  display: flex;
  align-items: center;
  gap: var(--margin);
}
.slug-display span {
  color: var(--color-text-secondary);
}
.slug-form {
  margin-top: var(--margin-xxl);
  padding-top: var(--padding-xxl);
  border-top: var(--border);
}
.slug-form h2 {
  margin-bottom: var(--margin);
}
.slug-info {
  margin-bottom: var(--margin-xl);
  font-size: var(--font-size);
  color: var(--color-text-secondary);
}
.slug-info a {
  color: var(--color-text-accent);
  text-decoration: none;
}
.slug-info a:hover {
  text-decoration: underline;
}
.slug-status {
  display: block;
  margin-top: var(--margin);
  font-size: var(--font-size);
}
.slug-status.checking {
  color: var(--color-info);
}
.slug-status.available {
  color: var(--color-success);
}
.slug-status.taken,
.slug-status.error {
  color: var(--color-danger);
}
.password-form {
  margin-top: var(--margin-xxl);
  padding-top: var(--padding-xxl);
  border-top: var(--border);
}
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}
.modal-content {
  background: var(--color-bg-primary);
  padding: var(--padding-xxl);
  border-radius: var(--border-radius);
  max-width: 500px;
  width: 90%;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}
.modal-content h2 {
  margin-top: 0;
  margin-bottom: var(--margin-xl);
}
.modal-content p {
  margin-bottom: var(--margin);
}
.modal-url {
  padding: var(--padding);
  background: var(--color-bg-secondary);
  border-radius: var(--border-radius);
  font-family: monospace;
  word-break: break-all;
}
.modal-warning {
  color: var(--color-warning);
  font-weight: 500;
  font-size: var(--font-size);
}
.modal-note {
  font-size: var(--font-size);
  color: var(--color-text-secondary);
  margin-bottom: var(--margin-xl);
}
@media (max-width: 768px) {
  .slug-display {
    flex-direction: column;
    align-items: flex-start;
    gap: var(--padding);
  }
  .modal-content {
    padding: var(--padding-xl);
  }
}
